import { useContext } from 'react';
import { mapWithDatabase } from '../../services/ConfigitService';
import { ConfigitContext } from '../ConfigitProvider';
import { ConfigitForm } from '../Filters/ConfigitForm';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export var ManufacturerProductSearch = function () { var _a = useContext(ConfigitContext), manufacturerProduct = _a.manufacturerProduct, setManufacturerProduct = _a.setManufacturerProduct, section = _a.section; var data; if (section) {
    data = mapWithDatabase([section])[0];
} return /*#__PURE__*/ _jsx(_Fragment, { children: data && /*#__PURE__*/ _jsx(ConfigitForm, { variableAssignments: manufacturerProduct, setVariableAssignments: setManufacturerProduct, section: data }) }); };
